/**
 * Fetch with timeout to prevent indefinite hangs on slow API
 * @param {string} url
 * @param {RequestInit} options
 * @param {number} timeoutMs - default 20000 (20 seconds)
 */
export async function fetchWithTimeout(url, options = {}, timeoutMs = 20000) {
  const controller = new AbortController();
  const id = setTimeout(() => {
    controller.abort(new DOMException(`Request timeout after ${timeoutMs}ms`, 'AbortError'));
  }, timeoutMs);
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal
    });
    return response;
  } finally {
    clearTimeout(id);
  }
}
